import { SVGProps } from "react";

export const ArchiveTick = (props: SVGProps<SVGSVGElement>) => {
  const fillColor = props.color ?? "#5656CA";
  const { color: _color, ...rest } = props;

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.59531 16.5872C3.28906 16.5872 3.00469 16.5143 2.74948 16.3685C2.18802 16.0404 1.86719 15.3768 1.86719 14.5529V4.27161C1.86719 2.41953 3.37656 0.910156 5.22865 0.910156H12.2651C14.1172 0.910156 15.6266 2.41953 15.6266 4.27161V14.5456C15.6266 15.3695 15.3057 16.0331 14.7443 16.3612C14.1828 16.6893 13.4464 16.6529 12.7245 16.2518L9.16615 14.2758C8.95469 14.1591 8.53906 14.1591 8.3276 14.2758L4.76927 16.2518C4.37552 16.4706 3.97448 16.5872 3.59531 16.5872ZM5.23594 2.00391C3.98906 2.00391 2.96823 3.02474 2.96823 4.27161V14.5456C2.96823 14.9758 3.09219 15.2966 3.31094 15.4206C3.52969 15.5445 3.8724 15.5081 4.24427 15.2966L7.8026 13.3206C8.34219 13.0216 9.15885 13.0216 9.69844 13.3206L13.2568 15.2966C13.6286 15.5081 13.9714 15.5518 14.1901 15.4206C14.4089 15.2893 14.5328 14.9685 14.5328 14.5456V4.27161C14.5328 3.02474 13.512 2.00391 12.2651 2.00391H5.23594Z"
        fill={fillColor}
      />
      <path
        d="M8.08607 9.66094C7.94753 9.66094 7.80898 9.6099 7.69961 9.50052L6.60586 8.40677C6.3944 8.19531 6.3944 7.84531 6.60586 7.63385C6.81732 7.4224 7.16732 7.4224 7.37878 7.63385L8.08607 8.34115L10.6163 5.81094C10.8277 5.59948 11.1777 5.59948 11.3892 5.81094C11.6007 6.0224 11.6007 6.3724 11.3892 6.58385L8.47253 9.50052C8.36315 9.6099 8.22461 9.66094 8.08607 9.66094Z"
        fill={fillColor}
      />
    </svg>
  );
};
